module.exports = __webpack_public_path__ + "img/jeremys-pro.193e0407.jpg";